import xhr from 'Common/utils/xhr'

export const getTeacherClasses = async ({
  version = null,
  includeDefault = true,
} = {}) => {
  const res = await xhr({
    url: `/api/v3/teachers/classes${version ? `?version=${version}` : ''}`,
    method: 'GET',
    withCredentials: true,
  })

  if (!includeDefault) return res.data.filter(c => !c.invitationDefaultClass)
  return res.data
}

export const getClassesContainingContent = async (queryParam, id) => {
  const res = await xhr({
    url: `/api/v3/class_contents/check_content?${queryParam}=${id}`,
    method: 'GET',
    withCredentials: true,
  })

  return res.data
}

export const addLessonToClass = async ({ data, isBulk }) => {
  const res = await xhr({
    url: `/api/v3/class_contents${isBulk ? '/bulk_create' : ''}`,
    method: 'POST',
    data,
  })

  return res.data
}

export const pinFolderToClass = ({ data }) => {
  return xhr({
    url: '/api/v1/class_folders',
    method: 'POST',
    data,
  })
}
